<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
        <div class="col gray">
          <h3>
            <i class="fas fa-ticket-alt"></i> Coupon Report
          </h3>
        </div>
        <div class="text-right">
          <label class="custom-toggle">
            <input v-model="couponBuyOrSell" type="checkbox" @change="setCouponReportData" id="couponCheck" />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div class="chart couponchart">
        <canvas id="couponChart"></canvas>
      </div>
      <a href @click="showPopup" class="view-more">View More<i class="fa fa-arrow-circle-right" ></i></a>
      <!-- <a href class="text-right view-more" @click="showPopup">View More</a> -->
    </div>
    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-xl"
      id="chartViewMoreCoupon"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Coupon Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="col-lg-9 col-5 tradeDate">
                <!-- <h4>Trade Date Range</h4>
                <form>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">From</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupFromDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupMaturityReportData"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlInput1">To</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="popupToDate"
                      placeholder="MM/DD/YYYY"
                      @change="getPopupMaturityReportData"
                    />
                  </div>
                </form> -->
              </div>
              <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input type="checkbox" v-model="popupCouponBuyOrSell" @change="setPopupCouponReportData">
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
              <!-- <div class="text-right">
                <label class="custom-toggle">
                  <input
                    v-model="popupMaturityBuyOrSell"
                    type="checkbox"
                    @change="setPopupMaturityReportData"
                  />
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
              </div> -->
            </div>
            <div class="graph">
              <canvas id="popupCouponChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
export default {
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getCouponReportData();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      couponBuyOrSell: false,
      couponChartOptions: chartConstants.couponBarChartDefault,
      couponChartData: {},
      popupCouponChartOptions: chartConstants.couponBarChartDefaultPopup,
      popupCouponChartData: {},
      popupCouponBuyOrSell: false,
      myChart : null,
      myChartPoup : null
      // popupFromDate: this.fromdate,
      // popupToDate: this.todate
    };
  },
  methods: {
    getCouponReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/coupon?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True",
          auth
        )
        .then(result => {
          this.couponChartData = result.data.data;
          this.setCouponReportData();
        });
    },
    setCouponReportData() {
      this.couponChartOptions.data.labels = this.couponBuyOrSell ?  this.couponChartData.sellsLabels : this.couponChartData.buysLabels;
      this.couponChartOptions.data.datasets[0].data = this.couponBuyOrSell
        ? this.couponChartData.sells
        : this.couponChartData.buys;

      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("couponChart");
      this.myChart = new window.Chart(ctx, {
        type: this.couponChartOptions.type,
        data: this.couponChartOptions.data,
        options: this.couponChartOptions.options
      });
    },
    getPopupCouponReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/coupon?fromDate=" +
             this.fromdate  +
            "&toDate=" +
             this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.popupCouponChartData = result.data.data;
          this.setPopupCouponReportData();
        });
    },
    setPopupCouponReportData() {
      this.popupCouponChartOptions.data.labels = this.popupCouponBuyOrSell ?  this.popupCouponChartData.sellsLabels : this.popupCouponChartData.buysLabels;
      this.popupCouponChartOptions.data.datasets[0].data = this
        .popupCouponBuyOrSell
        ? this.popupCouponChartData.sells
        : this.popupCouponChartData.buys;
      if(this.myChartPoup){
        this.myChartPoup.destroy();
      }
      const ctx = document.getElementById("popupCouponChart");
      this.myChartPoup = new window.Chart(ctx, {
        type: this.popupCouponChartOptions.type,
        data: this.popupCouponChartOptions.data,
        options: this.popupCouponChartOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      this.getPopupCouponReportData();
      window.$("#chartViewMoreCoupon").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getCouponReportData();
      }
    });
  }
};
</script>